<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)">阳光公示</a> / <span>公示详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="details">
            <h2 class="details_tit1">{{detail.pubDesc}}</h2>
            <p class="details_time">
              <span> 公示单位：{{detail.pubParty}}</span>
              <span> 公示状态：{{detail.pubStatusName}}</span>
              <span> 公示日期：{{detail.beginDate}}~{{detail.endDate}}</span>
            </p>
            <table v-if="detail.pubTypeCode==='apply'" width="100%" border="0" cellspacing="1" cellpadding="0">
              <tr class="first">
                <td>姓名</td>
                <td>身份证号</td>
                <td>待遇类别</td>
                <td>申报原因</td>
              </tr>
              <tr v-for="(item,index) in dataList" :key="item.itemId">
                <td align="center" nowrap="true">{{item.personName}}</td>
                <td align="center" nowrap="true">{{item.personUid}}</td>
                <td align="center" nowrap="true">&nbsp; {{item.archiveTypeCode}}</td>
                <td align="center">
                  <el-popover
                    offset="400"
                    placement="top-start"
                    width="300"
                    trigger="hover"
                  >
                    <div style="line-height: 22px;border-bottom: 1px solid #eaeff7;font-size: 14px;margin-top: 5px;">
                      <span style="font-weight: 600">申请原因：</span>{{item.reqReason}}
                    </div>
                    <el-button slot="reference">原因</el-button>
                  </el-popover>
                </td>
              </tr>
            </table>
            <table v-if="detail.pubTypeCode==='pay'" width="100%" border="0" cellspacing="1" cellpadding="0">
              <tr class="first">
                <td>姓名</td>
                <td>身份证号</td>
                <td>资金科目</td>
                <td>实发合计(元)</td>
                <td>发放日期</td>
              </tr>
              <tr v-for="(item,index) in dataList" :key="item.itemId">
                <td align="center" nowrap="true">{{item.personName}}</td>
                <td align="center" nowrap="true">{{item.personUid}}</td>
                <td align="center" nowrap="true">&nbsp; {{item.className}}</td>
                <td align="center" nowrap="true">&nbsp; {{item.amount}}</td>
                <td align="center" nowrap="true">&nbsp; {{item.payDate}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "SunNoticeDetail",
    components: {
      headers, fixedDiv, footers
    },
    data() {
      return {
        detail: {},
        detail_id: '',
        dataList: [],
      }
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.getDetail();
    },
    methods: {
      //获取政策文件详细
      getDetail() {
        this.$https.post("/api/pubItem/getPubItemInfo.do", {pubId: this.detail_id}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.detail = response.data.data;
            if (!this.$util.isEmpty(this.detail)){
              this.dataList=this.detail.itemData
            }
          }
        });
      },
      //下载附件
      downloadAttach() {
        // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
        // });
      }
    }
  }
</script>

<style scoped>
  .first td {
    background: #eaeff7;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #909090;
  }
  table td {
    background: #fff;
    height: 52px;
    word-wrap: break-word;
    word-break: break-all;
    padding: 0px 10px;
  }
  table td a.complaint {
    background: url(../../../static/images/publicity_complaint.png) no-repeat left center;
    padding-left: 21px;
    color: #2162f0;
  }
  table td a:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/pages/detail/SunNoticeDetail.vue